"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyAttempt = applyAttempt;
exports.daysBetween = daysBetween;
// Simple pure update function. No IO. Returns updated snapshot.
function applyAttempt(prev, attempt, policies, nowIso) {
    const lesson = {
        ...(prev.lessons[attempt.lessonId] ?? {
            lessonId: attempt.lessonId,
            attempts: 0,
            bestAccuracy: 0,
        }),
    };
    lesson.attempts += 1;
    if (attempt.accuracy > lesson.bestAccuracy) {
        lesson.bestAccuracy = attempt.accuracy;
    }
    lesson.lastAttemptAt = attempt.timestamp;
    // XP calculation (simplified)
    const accuracyFactor = policies.xp.accuracyMultiplier ? attempt.accuracy : 1;
    const xpDelta = attempt.xpGained ?? Math.round(policies.xp.basePerAttempt * accuracyFactor);
    // Streak logic (simplified): if last snapshot day < now day - maxGap => reset
    let streakDays = prev.streakDays;
    if (prev.generatedAt) {
        const prevDay = prev.generatedAt.slice(0, 10);
        const nowDay = nowIso.slice(0, 10);
        if (prevDay === nowDay) {
            // same day, keep streak
        }
        else {
            const gapDays = daysBetween(prevDay, nowDay);
            if (gapDays === 1)
                streakDays += 1;
            else if (gapDays > policies.streak.maxGapDays)
                streakDays = 1;
        }
    }
    else {
        streakDays = 1;
    }
    const updated = {
        ...prev,
        streakDays,
        xpTotal: prev.xpTotal + xpDelta,
        lessons: { ...prev.lessons, [lesson.lessonId]: lesson },
        generatedAt: nowIso,
    };
    return { snapshot: updated, lesson, xpDelta };
}
// Helper pure function to count whole-day difference (naive, UTC-based)
function daysBetween(dayA, dayB) {
    // dayA, dayB format: YYYY-MM-DD
    const a = Date.parse(dayA + "T00:00:00Z");
    const b = Date.parse(dayB + "T00:00:00Z");
    return Math.round((b - a) / 86400000);
}
//# sourceMappingURL=progressCalculator.js.map